import SessionsList from "../components/SessionsList";
import InfoModal from "../components/InfoModal";
import UserMenu from "../components/UserMenu";

const SessionsPage = () => {
  return (
    <div class="h-screen overflow-y-auto">
      {/* Original Coach P Header */}
      <header class="bg-blue-500 text-white py-4 shadow relative flex-shrink-0">
        <h1 class="text-center text-2xl font-bold tracking-wide">
          IntelliCoach
        </h1>
        <div class="absolute top-4 right-4 flex items-center space-x-3">
          <UserMenu />
          <InfoModal />
        </div>
      </header>

      <SessionsList />
    </div>
  );
};

export default SessionsPage;
